export enum ButtonTypes {
    dark = 'dark',
    outlined = 'outlined',
    outlinedLight = 'outlined-light',
    primary = 'primary',
    smallPr = 'small-pr'
}